import { createMiddleware } from 'hono/factory';
import type { AppContext, Env, User } from './types.js';

export const PERMISSIONS = {
	ADMIN: 'admin',
	ADMIN_USERS: 'admin:users',
	ADMIN_FLAGS: 'admin:flags',
	ADMIN_TRANSLATIONS: 'admin:translations',
	ADMIN_SETTINGS: 'admin:settings',
} as const;

export function parsePermissions(raw: unknown): string[] {
	if (typeof raw === 'string') {
		try {
			const parsed = JSON.parse(raw);
			if (Array.isArray(parsed)) return parsed.filter((v): v is string => typeof v === 'string');
		} catch {}
	}
	if (Array.isArray(raw)) return raw.filter((v): v is string => typeof v === 'string');
	return [];
}

export function hasPermission(user: User | null, permission: string): boolean {
	if (!user) {
		return false;
	}

	// Admin superuser has all permissions
	if (user.permissions.includes(PERMISSIONS.ADMIN)) return true;

	return user.permissions.includes(permission);
}

export function requirePermission(permission: string) {
	return createMiddleware<{ Bindings: Env; Variables: AppContext }>(async (c, next) => {
		const user = c.get('user');

		if (!hasPermission(user, permission)) {
			if (c.req.path.includes('/api/')) {
				return c.json({ error: 'Forbidden' }, 403);
			}
			return c.redirect('/');
		}

		await next();
	});
}
